import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from '@tanstack/react-router';

import {
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuRoot,
} from '@repo/lib-design-system/primitives/navigation-menu.component';

import Logout from './logout.component';

import SelectLanguage from '@/shared/components/languages/select-language';
import { ThemeToggle } from '@/shared/components/theme/theme-toggle.component';
import { getStoredToken } from '@/shared/services/session.service';

export function Nav(): ReactElement {
  const { t } = useTranslation();
  const pathname = useLocation({ select: (location) => location.pathname });
  const isLoggedIn = getStoredToken() !== null;

  return (
    <NavigationMenuRoot>
      <NavigationMenuList>
        <NavigationMenuItem>
          <SelectLanguage />
        </NavigationMenuItem>
        <NavigationMenuItem>
          <ThemeToggle />
        </NavigationMenuItem>
        {pathname.includes('/faq') && (
          <NavigationMenuItem>
            <NavigationMenuLink className="mx-2" asChild>
              <Link to="/">{t('header.customerHub')}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}
        {isLoggedIn && (
          <NavigationMenuItem>
            <Logout />
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenuRoot>
  );
}

export default Nav;
